export default __webpack_public_path__ + "static/media/002-ice cream bar.a304556c.svg";